<template>
  <div class="animated fadeIn">
    <Tables
      ref="tableGrid"
      :columns="['DATA ENVIO','RESPONSÁVEL', 'NOME ARQUIVO', 'TAMANHO', 'AÇÕES']"
      :showUpload="hasRole(roles.ADMINISTRADOR)"
      :showSearch="true"
      :showTipFooter="false"
      :showReload="true"
      v-on:Search="onShowSearch"
      v-on:Upload="onNew"
      v-on:Load="onLoad"
      v-on:Reload="onLoad"
    >
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn
          :IsTextNoLink="true"
          :status="1"
          :value="formatDate(obj.anexo.dataEnvio)"
        />
        <TableColumn
          :IsTextNoLink="true"
          :status="1"
          :value="obj.usuarioResponsavel.nomePessoa"
        />
        <TableColumn
          :IsTextNoLink="true"
          :status="1"
          :value="obj.anexo.nomeOriginal"
        />
        <TableColumn
          :IsTextNoLink="true"
          :status="1"
          :value="formatBytes(obj.anexo.tamanho)"
        />
        <td>
          <div class="d-flex justify-content-center">
            <i @click="downloadAttachment(obj)" class="fas fa-file-download text-third cursor-pointer pr-3"></i>
            <b-dropdown
              v-if="hasRole(roles.ADMINISTRADOR)"
              variant="link"
              size="sm"
              no-caret
            >
              <template slot="button-content">
                <i class="fas fa-trash-alt text-danger"></i>
              </template>
              <b-dropdown-header>
                <strong>{{$lang.Common.ConfirmCancel}}</strong>
              </b-dropdown-header>
              <b-dropdown-item
                href="javascript:void(0);"
                v-on:click="deleteAttachment(obj)"
              >
                {{$lang.Common.Yes}}
              </b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
            </b-dropdown>
          </div>
        </td>
      </tr>
    </Tables>
    <div class="row" v-if="hasRole(roles.ADMINISTRADOR)">
      <div class="col-12 pb-3 pl-4">
        <button
          type="button"
          class="btn btn-third btn-sm"
          @click="onNew"
          v-b-tooltip.hover
          :title="'Clique para realizar Upload'"
        >
          <i class="fas fa-plus-circle"></i> <span class="d-md-down-none"> Nova Importação</span>
      </button>
      </div>
    </div>
    <AttachmentModal ref="AttachmentModal" v-on:Back="onBackNewAttach" />
    <SidebarSearch @search="onSearch" />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading, toast } from '@/shared/utils/UIHelper'

import AttachmentRepository from '@/shared/http/repositories/configurations/attachment.js'
import AttachmentModal from '@/views/private/attachments/components/modal/importmodal.vue'
import SidebarSearch from '@/views/private/attachments/components/search/SidebarAnexos.vue'
import Download from '@/shared/http/repositories/download/download'

export default {
  name: 'AttachmentList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null
    }
  },
  components: {
    AttachmentModal, SidebarSearch
  },
  methods: {
    onNew () {
      this.$refs.AttachmentModal.showModal()
    },
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      if (this.filters) {
        AttachmentRepository.Search(this.createRequestParam(), this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        AttachmentRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onGetAttachment (obj) {
      AttachmentRepository.GetAttachmentShareById(obj.id)
        .then((response) => {
          if (response.status === 200) {
            var data = response.data
            if (data && data.uuid) {
              Download.GetDownloadUrl(data.uuid, { responseType: 'blob' })
                .then(resp => {
                  const contentDisposition = resp.headers['content-disposition']
                  let fileName = 'arquivo'

                  if (contentDisposition) {
                    const match = contentDisposition.match(/filename="?([^"]+)"?/)
                    if (match && match[1]) {
                      fileName = match[1]
                    }
                  }
                  const blob = resp.data
                  const url = window.URL.createObjectURL(blob)
                  const a = document.createElement('a')
                  a.href = url
                  a.download = fileName
                  document.body.appendChild(a)
                  a.click()
                  a.remove()
                  window.URL.revokeObjectURL(url)
                })
                .catch(err => {
                  console.error('Erro ao baixar o arquivo:', err)
                })
            }
          }
        })
        .catch(this.onException)
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    onBackNewAttach () {
      this.onLoad()
    },
    createRequestParam () {
      let listParam = []
      if (this.filters.nomeOriginal) listParam.push('nomeOriginal=' + this.filters.nomeOriginal)
      if (this.filters.dataEnvio) listParam.push('dataEnvio=' + this.filters.dataEnvio)
      return listParam.join('&')
    },
    formatDate (value) {
      let result = ''
      if (value) {
        result = this.moment(value).format('DD/MM/YYYY HH:mm')
      }
      return result
    },
    downloadAttachment (obj) {
      this.onGetAttachment(obj)
    },
    deleteAttachment (obj) {
      loading.push()
      AttachmentRepository.Delete(obj.id)
        .then((response) => {
          if (response.status === 200) {
            toast.success(`Arquivo ${obj.anexo.nomeOriginal} foi deletado !`, 'IMPORTAÇÃO')
            this.onLoadAll()
            loading.pop()
          }
        })
        .catch(this.onException)
    },
    formatBytes (value) {
      return Tools.readableBytes(value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/attachments/components/list/attachmentlist.vue